(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elbeimker-category-bubbles"] && !Shopify.designMode) return;
  try {
    
  // Aktive Kategorie in den sichtbaren Bereich scrollen (nur wenn die Zeile überläuft)
  document.querySelectorAll('.eib__list').forEach((list) => {
    const current = list.querySelector('.is-current');
    if (!current || list.scrollWidth <= list.clientWidth) return;
    const item = current.closest('.eib__item') || current;
    const offset = item.getBoundingClientRect().left - list.getBoundingClientRect().left + list.scrollLeft;
    list.scrollLeft = offset - (list.clientWidth - item.offsetWidth) / 2;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
